<template>
  <Card class="my-4 relative overflow-hidden" :class="{ 'border border-yellow-300' : selected}">
    <span class="absolute -left-6 top-3  transform -rotate-45 w-24 text-center bg-yellow-300 p-1 text-xs"
          v-if="selected">فعال </span>
    <div class="flex items-center justify-between">
      <div class="text-gray-500 text-sm">
        <div class="flex items-center mt-3">
          
          <span class="mr-1">{{ name }}</span>
        </div>
      </div>
    </div>
    <hr class="mt-1">
    <div class="flex justify-between">
      <router-link :to="`/menu/${menuid}/edit/${id}`" class="bg-yellow-300 px-5 rounded-xl p-2 mt-2 text-xs">ویرایش
      </router-link>
      <router-link :to="`/cat/${id}`" class="bg-yellow-300 rounded-xl px-6 p-2 mt-2 text-xs">کالاها({{ itemCount }})
      </router-link>
      <Button class="bg-red-400 rounded-xl p-2 mt-2 text-xs px-6 text-gray-100" @click="deleteCat">حذف</Button>
    </div>
  </Card>


</template>

<script>

import Card from "@/components/General/VCard"
import Button from "@/components/General/VButton";
  
  export default {
    props: ['id','menuid','itemCount', 'name','isactive','sortorder','selected'],
    name: 'CategoryCard',
    emits: ['deleted'],
    components: {Card,Button},
    methods: {
      deleteCat() {
        this.$emit('deleted', this.id)
      }
    }
  }
  </script>
